import { createPersistValue } from '@ui/features/Trade/store/createPersistValue';
import { useIsMounted } from '@ui/hooks/useIsMounted';
import { getLocalStorageKey } from '@ui/utils/getLocalStorageKey';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type IsLongState = {
  _isLong: boolean;
};

export const useIsLong = createPersistValue<boolean>('trade.isLong', true);